import { useUTMStore } from '@/stores/modules/utm';
import type VueRouter from 'vue-router';

export default function saveUTMParamsGuard(router: VueRouter) {
  /**
   * 切换路由前保存UTM参数
   */
  router.beforeEach((to, from, next) => {
    // eslint-disable-next-line camelcase
    const { utm_source, utm_medium, utm_campaign, utm_content, utm_term } = to.query as Record<
      string,
      string | null
    >;

    // 记录url中的utm_source参数
    const utmStore = useUTMStore();

    console.log(utm_source);

    utmStore.update({
      source: utm_source,
      medium: utm_medium,
      campaign: utm_campaign,
      content: utm_content,
      term: utm_term,
    });

    next();
  });
}
